















import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch,
  Mixins
} from "vue-property-decorator";
import * as types from "@/store/constants/index_types";
import Button from "@/components/Button/Button.vue";

@Component({
  components: { Button }
})
export default class AddAcount extends Vue {
  @Emit("addAccount")
  private addAccount() {
    // console.log("click");
  }
}
